import { render, staticRenderFns } from "./Navbar.html?vue&type=template&id=3162facd&"
import script from "./Navbar.ts?vue&type=script&lang=ts&"
export * from "./Navbar.ts?vue&type=script&lang=ts&"
import style0 from "@/scss/components/navbar/_navbar.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports